import { useEffect, useState } from "react";
import axios from "axios";
import Light from "components/headers/light";
import AnimationRevealPage from "helpers/AnimationRevealPage";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import Swal from "sweetalert2";
import { FaEdit, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom"; // Import useNavigate hook
import './orders.css';  // Assure-toi que le chemin est correct
import { useTranslation } from 'react-i18next';
import AnnouncementBanner from "components/AnnouncementBanner";

const Orders = () => {
     const { i18n } = useTranslation();

  const currentLang = i18n.language; // e.g. 'fr' or 'ar'

    const { t } = useTranslation();
    const [orders, setOrders] = useState([]);
    const [gainsUser, setGainuser] = useState([]);
    const [retraite, setRetraite] = useState([]);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [editedOrder, setEditedOrder] = useState({});
    const token = localStorage.getItem("authToken");
    const role = localStorage.getItem("role"); // Assuming role is saved in localStorage
    const navigate = useNavigate(); // Initialize navigate
useEffect(() => {
    if (!token || role !== "supplier") {
        Swal.fire({
            icon: "error",
            title: t("Non_autorisé"),
            text: t("Connexion_fournisseur_requise"),
        }).then(() => {
            navigate("/login");
        });
        return;
    }
    fetchAllOrders();
}, [token, role, navigate]);
    const fetchAllOrders = async () => {
        try {
            const token = localStorage.getItem("authToken");
            if (!token) {
                return;
            }
            const response = await axios.get("https://elanciabioapi.com/api/supplier/get-ordersAdmin", {
                headers: { Authorization: `Bearer ${token}` },
            });
            if (response.status === 200) {
                setGainuser(response.data.userGain);
                setOrders(response.data.orders);
                setRetraite(response.data.retraite)
            } else {
                return;
            }
        } catch (error) {
                return;
        }
    };
    const gainsPaye = orders
    .filter((order) => order.status === "livré" && order.retraite === 0) // Add the retrait condition here
    .reduce((sum, order) => sum + (order.gain || 0), 0);
    const totalGains = orders.reduce((sum, order) => sum + (order.gain || 0), 0);
    const gainsLivre = orders
        .filter((order) => order.status === "livré")
        .reduce((sum, order) => sum + (order.gain || 0), 0);
    const gainsLivrepasRetraite = orders
        .filter((order) => order.status === "livré" && order.retraite === 0)
        .reduce((sum, order) => sum + (order.gain || 0), 0);
    const pendingOrders = orders.filter(order => order.status === "en attente").length;
    const completedOrders = orders.filter(order => order.status === "livré").length;
    const cancelledOrders = orders.filter(order => order.status === "annulé").length;
    const totalRevenue = orders.reduce((sum, order) => sum + Number(order.total || 0), 0);
    const gains = gainsUser;
const retraites1 = Number(retraite) || 0;
const handleEdit = (order) => {
        setSelectedOrder(order);
        setEditedOrder({
            CustomerID: order.customer?.CustomerID || "",
            Name: order.customer?.CustomerName || "",
            Phone: order.customer?.Phone || "",
            Address: order.customer?.Address || "",
            City: order.customer?.City || "",
        });
        setIsEditModalOpen(true);
    };

const handleDelete = async (orderId) => {
    Swal.fire({
        title: t("Etes_vous_sur"),
        text: t("Action_irreversible"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: t("Oui_supprimer"),
        cancelButtonText: t("Annuler"),
    }).then(async (result) => {
        if (result.isConfirmed) {
            try {
                const token = localStorage.getItem("authToken");
                await axios.delete(`https://elanciabioapi.com/api/supplier/orders/${orderId}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                Swal.fire(t("Supprime"), t("Commande_supprimee"), "success");
                fetchAllOrders();
            } catch (error) {
                Swal.fire(t("Erreur"), t("Suppression_impossible"), "error");
            }
        }
    });
};


const handleSave = async (e) => {
    e.preventDefault();
    if (!selectedOrder) return;
    try {
        await axios.put(
            `https://elanciabioapi.com/api/supplier/orders/${selectedOrder.orderId}`,
            editedOrder,
            { headers: { Authorization: `Bearer ${token}` } }
        );
        Swal.fire(t("Succes"), t("Commande_modifiee"), "success");
        fetchAllOrders();
        setIsEditModalOpen(false);
    } catch (error) {
        Swal.fire(t("Erreur"), t("Modification_impossible"), "error");
    }
};

    const handleWithdrawRequest = async (gain) => {
    try {
        const token = localStorage.getItem("authToken");
        if (!token) {
            Swal.fire({
                icon: "error",
                title: t("Erreur"),
                text: t("Token_introuvable"),
            });
            return;
        }

        const response = await axios.post(
            "https://elanciabioapi.com/api/withdraw",
            { gain },
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        if (response.status === 200) {
            Swal.fire({
                icon: "success",
                title: t("Succes"),
                text: t("Retrait_succes"),
            });
        } else {
            Swal.fire({
                icon: "error",
                title: t("Echec"),
                text: t("Retrait_echec"),
            });
        }
    } catch (error) {
        Swal.fire({
            icon: "error",
            title: t("Erreur"),
            text: t("Retrait_erreur"),
        });
    }
};
    // Check if the order should be disabled (grayed out)
    const isDisabled = (order) => order.status === "livré" && order.retraite === 1;
console.log(orders);
    return (
        <AnimationRevealPage>
            <Light />
<br/>

                                        <AnnouncementBanner/>

            <div className="d-flex">
                <section className="w-100 p-3">
                    <div className="d-flex justify-content-between align-items-center gap-2">
                        <h1 className="text-dark display-4">{t('Tableau_de_bord_commandes')}</h1>
                        <button 
className="btn" 
style={{ 
    backgroundColor: '#336734', 
    color: 'white', 
    border: 'none', 
    padding: '10px 20px', 
    fontSize: '16px', 
    borderRadius: '5px', 
    fontWeight: 'bold' 
}}                        onClick={() => handleWithdrawRequest(gainsLivrepasRetraite)}>
                           {t('Demander_retrait')}
                        </button>
                    </div>
                    <hr className="my-4" />

                    {/* Cards Section */}
                    <div className="row g-3 mb-4">
                        {[ 
{ title: t("Commandes_en_attente"), value: pendingOrders },
  { title: t("Commandes_livrees"), value: completedOrders },
  { title: t("Commandes_annulees"), value: cancelledOrders },
  { title: t("Revenu_total"), value: `${totalRevenue} DH` },
  { title: t("Total_gains"), value: `${totalGains} DH` },
  { title: t("Gains_commandes_livrees"), value: `${gainsLivre} DH` },
  { title: t("Gains_non_retires"), value: `${gainsLivrepasRetraite} DH` },
  { title: t("Total_retraites"), value: `${retraites1} DH` }
                            // { title: "Gains en attente", value: `${gainsEnattente} DH` }
                        ].map((item, index) => (
                            <div className="col-md-4" key={index}>
                               <div className={`card shadow-sm text-white ${[
    "bg-primary-500",   // Lighter variant 1
    "bg-primary-400",   // Lighter variant 2
    "bg-primary-300",   // Lighter variant 3
    "bg-primary-200",   // Lighter variant 4
    "bg-primary-100",   // Lighter variant 5
    "bg-primary-600",   // Lighter variant 5
    "bg-primary-300",   // Lighter variant 3
    "bg-primary-400",   // Lighter variant 2

][index]}`}>


                                    <div className="card-body text-center">
                                        <h5 className="card-title">{item.title}</h5>
                                        <p className="card-text display-6">{item.value}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Orders Table */}
                    <div className="table-responsive">
                        <table className="table table-striped table-bordered">
                            <thead>
                                <tr>
                                   <th>{t("ID_de_commande")}</th>
<th>{t("Informations_client")}</th>
<th>{t("Produits")}</th>
<th>{t("Statut")}</th>
<th>{t("Statut_Paiement")}</th>
<th>{t("Gains")}</th>
<th>{t("Total")}</th>
<th>{t("Actions")}</th>

                                </tr>
                            </thead>
                            <tbody>
                                {orders.map((order) => (
                                    <tr
                                        key={order.orderId}
                                        style={{
                                            backgroundColor: isDisabled(order) ? "#f0f0f0" : "",
                                            opacity: isDisabled(order) ? 0.6 : 1,
                                            pointerEvents: isDisabled(order) ? "none" : "auto",
                                        }}
                                    >
                                        <td>{order.idsOrder}</td>
                                        <td>
                                            <div>{order.customer?.CustomerName}</div>
                                            <div>{order.customer?.Phone}</div>
                                            <div>{order.customer?.Address}</div>
                                            <div>{order.customer?.City}</div>
                                        </td>
 <td>
      {order.products?.map(p => {
        const name = currentLang === 'ar' ? (p.name.ar || p.name.fr) : (p.name.fr || p.name.ar);
        return `${name} (x${p.quantity})`;
      }).join(", ")}
    </td>                                        <td>{order.Status}</td>
                                        <td>{order.paymentStatus}</td>
                                        <td>{order.gain} DH</td>
                                        <td>{Number(order.total) + 40} DH</td>
                                        <td>
    <button 
        className="btn btn-warning me-2" 
        onClick={() => handleEdit(order)}
        disabled={order.status === "livré"} // Désactive si la commande est livrée
    >
        <FaEdit /> {/* Edit Icon */}
    </button>
    
    <button 
    style={{ backgroundColor: 'red' }}
        className="btn btn-danger" 
        onClick={() => handleDelete(order.orderId)}
        disabled={order.status === "livré"} // Désactive si la commande est livrée
    >
<FaTrash style={{ color: 'white' }} /> {/* Red color for the trash icon */}
    </button>
</td>

                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
               {/* Modal for editing */}
               {isEditModalOpen && selectedOrder && (
                    <div className="modal show d-block" id="editModal" tabIndex="-1">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">{t('Modifier_Commande')}</h5>
                                    <button type="button" className="btn-close" onClick={() => setIsEditModalOpen(false)}></button>
                                </div>
                                <div className="modal-body">
                                    <form onSubmit={handleSave}>
                                        <div className="mb-3">
                                            <label htmlFor="customerName" className="form-label">{t('Nom_du_client')}</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="customerName"
                                                value={editedOrder.Name}
                                                onChange={(e) => setEditedOrder({ ...editedOrder, Name: e.target.value })}
                                                required
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="customerPhone" className="form-label">{t('Numéro_de_Téléphone')}</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="customerPhone"
                                                value={editedOrder.Phone}
                                                onChange={(e) => setEditedOrder({ ...editedOrder, Phone: e.target.value })}
                                                required
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="customerAddress" className="form-label">{t('Adresse')}</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="customerAddress"
                                                value={editedOrder.Address}
                                                onChange={(e) => setEditedOrder({ ...editedOrder, Address: e.target.value })}
                                                required
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="customerCity" className="form-label">{t('Ville')}</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="customerCity"
                                                value={editedOrder.City}
                                                onChange={(e) => setEditedOrder({ ...editedOrder, City: e.target.value })}
                                                required
                                            />
                                        </div>
                                        <button type="submit" className="btn btn-primary">{t('Sauvegarder')}</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </section>
        </div>
    </AnimationRevealPage>
    );
};

export default Orders;
